import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import * as React from "react";
import {Link} from "react-scroll";

import styles from "./SiteHeader.module.scss";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  children: React.ReactElement;
  window?: () => Window;
}

function ElevationScroll(props: Props) {
  const {children, window} = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    target: window ? window() : undefined,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const drawerWidth = 240;
const pages = [
  {id: "product", label: "Product"},
  {id: "mobile-app", label: "Mobile App"},
  {id: "about-us", label: "About Us"},
];

export const SiteHeader = (props: Props) => {
  // const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
  //   null
  // );
  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  const {window} = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{textAlign: "center"}}>
      <Typography variant="h4" sx={{my: 2}} color={"secondary"}>
        Checkafy
      </Typography>
      <Divider />
      <List>
        {pages.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton sx={{textAlign: "center"}}>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box className={styles.siteHeader}>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar className={styles.appBar} component="nav">
          <Container maxWidth="lg">
            <Toolbar className={styles.toolbar}>
              <IconButton
                color="primary"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={styles.menuButton}
              >
                <MenuIcon />
              </IconButton>

              <Box className={styles.logoBox} component="div" color="white">
                <Link key={"top"} activeClass="active" to={"top"} offset={-150}>
                  <img src="/top_bar_icon.png" className={styles.icon} alt="" />
                </Link>
              </Box>
              <Box className={styles.headerOptions}>
                {pages.map((item) => (
                  <Link
                    key={item.id}
                    activeClass="active"
                    to={item.id}
                    offset={-150}
                  >
                    <Button sx={{height: "60px", mr: 1}}>{item.label}</Button>
                  </Link>
                ))}
                <Button sx={{ml: 2}} variant="outlined" size="large" disabled>
                  Login
                </Button>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </ElevationScroll>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
            display: {sm: "block", xs: "block"},
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Container
        maxWidth="lg"
        component="main"
        sx={{background: "white", maxWidth: "1500px", p: 3}}
      >
        <div id="top" />
        <div>{props.children}</div>
      </Container>
    </Box>
  );
};

// const {Header, Content} = Layout;

// export const SiteHeader: React.FC = () => {
//   const [headerClass, setHeaderClass] = React.useState<string>("header");
//   const aboutEl = React.useRef<HTMLDivElement>(null);
//   const downloadEl = React.useRef<HTMLDivElement>(null);
//   const featureEl = React.useRef<HTMLDivElement>(null);

//   // const classes = useStyles();

//   useEffect(() => {
//     // componentDidMount
//     // Anything in here is fired on component mount.
//     window.scrollTo(0, 0);
//     window.addEventListener("scroll", handleScroll);
//   }, []);

//   const handleScroll = () => {
//     console.log("window.scrollY", window.scrollY);
//     if (window.scrollY > 0) {
//       setHeaderClass("header-white");
//     } else {
//       setHeaderClass("header");
//     }
//   };

//   const scrollToRef = (ref: HTMLElement) =>
//     window.scrollTo(0, ref.offsetTop - 80);

//   const handleMenuClick = (e: any) => {
//     if (e.key === "1") {
//       // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
//       scrollToRef(featureEl.current!);
//     } else if (e.key === "2") {
//       // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
//       scrollToRef(downloadEl.current!);
//     } else if (e.key === "3") {
//       // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
//       scrollToRef(aboutEl.current!);
//     }
//   };

//   const menuItems = [
//     {
//       className: styles.menuItem,
//       icon: <>Product</>,
//       key: "1",
//     },
//     {
//       className: styles.menuItem,
//       icon: <>Mobile App</>,
//       key: "2",
//     },
//     {
//       className: styles.menuItem,
//       icon: <>About Us</>,
//       key: "3",
//     },
//   ];

//   return (
//     <div>
//       <>{headerClass}</>
//       <Header
//         className={clsx(styles.header, styles.headerWhite)}
//         hidden={headerClass == "header-white"}
//       >
//         <div className={styles.logo}>
//           <img src="/top_bar_icon.png" className={styles.icon} alt="" />
//         </div>

//         <Tabs
//           value={menuItems}
//           onChange={handleMenuClick}
//           textColor="secondary"
//           indicatorColor="secondary"
//           aria-label="secondary tabs example"
//         >
//           <Tab value="one" label="Product" />
//           <Tab value="two" label="Mobile App" />
//           <Tab value="three" label="About Us" />
//         </Tabs>

//         <Button
//           variant="outlined"
//           color="primary"
//           type="button"
//           onClick={(event) => {
//             event.preventDefault();
//           }}
//         >
//           Login
//         </Button>
//       </Header>

//       <Content>
//         <div className={styles.contentBox}>
//           <Core />

//           <div ref={featureEl}>
//             <Feature />
//           </div>

//           <div ref={downloadEl}>
//             <Download />
//           </div>

//           <div ref={aboutEl}>
//             <About />
//           </div>
//         </div>
//       </Content>
//     </div>
//   );
// };
